import React, { useContext, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { t } from '@common/helpers/translator';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { PopupContext } from '@app/dev/contexts/popup';
import Config from '@app/dev/config/main';
import { POPUPS } from '@common/constants/popups';
import NumericInput from '@common/components/numericInput';
import { getSwarmSetRfidPinCodeRequest } from '../../../helpers/terminalRequests/rfid';

import './style.scss';

const ResetPinCode = ({ rfid }) => {
  const [checkLoading, setCheckLoading] = useState(false);
  const [formErrored, setFormErrored] = useState(false);
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const [form, setForm] = useState({
    documentId: '',
  });
  const isAdminLoggedIn = useSelector((state) => state.terminal.isAdminLoggedIn);

  const isFormValid = useMemo(() => form.documentId, [form]);
  const submitDisabled = useMemo(
    () => !isFormValid || (Config.main.needAdminForResetPin && !isAdminLoggedIn) || checkLoading || !rfid,
    [isFormValid, isAdminLoggedIn, checkLoading, rfid],
  );

  const fieldChange = (name, value) => {
    formErrored && setFormErrored(false);
    setForm({
      ...form,
      [name]: value,
    });
  };

  const submit = async () => {
    if (submitDisabled) return;

    try {
      setCheckLoading(true);
      const { token } = JSON.parse(sessionStorage.getItem('authData'));
      const result = await swarmRequest({ token, filter: { rfid } }, 'terminal_find_player');

      if (!result?.data?.length) throw new Error();

      const docNumber = result?.data?.[0].DocNumber;
      if (docNumber !== form.documentId) {
        setForm({ ...form, documentId: '' });
        setFormErrored(true);
        setCheckLoading(false);
      } else if (!Config.main.needAdminForResetPin) {
        openPopup(POPUPS.SET_PIN_CODE, { rfid, loggedIn: true, loginPin: '0000' });
      } else {
        const params = {
          PinCode: '0000',
          Rfid: rfid,
        };

        await swarmRequest(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');
        closePopup();
      }
    } catch {
      setForm({ ...form, documentId: '' });
      setFormErrored(true);
      setCheckLoading(false);
    }
  };

  return (
    <div className="popup-content popup-small">
      <div className="popup-title">{t('Reset PIN Code')}</div>
      <div className="popup-main-content">
        {Config.main.needAdminForResetPin && !isAdminLoggedIn && (
          <p className="text-center">{t('Please ask administrator for confirmation')}</p>
        )}
        <div className="input-wrapper">
          <p className="popup-txt">{t('Document ID')}</p>
          <div className="input-row">
            <NumericInput
              className="numeric-input"
              value={form.documentId}
              onChange={(value) => fieldChange('documentId', value)}
            />
          </div>
        </div>
        {formErrored && (
          <div className="error-row" style={{ display: '' }}>
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t('Invalid Code')}</p>
          </div>
        )}
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={closePopup}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={submit}
          className={`popup-confirm-button ${submitDisabled ? 'disabled' : ''}`}
        >
          {t('Submit')}
        </button>
      </div>

    </div>
  );
};

export default ResetPinCode;
